var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useMemo } from "react";
import { NormalizedClearInvisibleValues, TextUpdateMode, } from "../../../types/forms";
import { evaluateElementConditions } from "../../../utils/elements-condition";
var FormLogicContext = createContext({
    formValues: {},
    globalConstraints: {},
    elementsTypeInfoByName: {},
    pageEnabledFallback: true,
    isDisplayMode: false,
    textUpdateMode: TextUpdateMode.ON_BLUR,
    clearInvisibleValues: NormalizedClearInvisibleValues.ON_COMPLETE,
    storeOthersAsComment: true,
});
var defaultContextValue = {
    formValues: {},
    globalConstraints: {},
    elementsTypeInfoByName: {},
    pageEnabledFallback: true,
    isDisplayMode: false,
    textUpdateMode: TextUpdateMode.ON_BLUR,
    clearInvisibleValues: NormalizedClearInvisibleValues.ON_COMPLETE,
    storeOthersAsComment: true,
};
var FormLogicProvider = function (_a) {
    var formValues = _a.formValues, elementsTypeInfoByName = _a.elementsTypeInfoByName, _b = _a.globalConstraints, globalConstraints = _b === void 0 ? {} : _b, _c = _a.pageEnabledFallback, pageEnabledFallback = _c === void 0 ? true : _c, _d = _a.isDisplayMode, isDisplayMode = _d === void 0 ? false : _d, _e = _a.textUpdateMode, textUpdateMode = _e === void 0 ? TextUpdateMode.ON_BLUR : _e, _f = _a.clearInvisibleValues, clearInvisibleValues = _f === void 0 ? NormalizedClearInvisibleValues.ON_COMPLETE : _f, _g = _a.storeOthersAsComment, storeOthersAsComment = _g === void 0 ? true : _g, children = _a.children;
    return (_jsx(FormLogicContext.Provider, __assign({ value: {
            formValues: formValues,
            globalConstraints: globalConstraints,
            elementsTypeInfoByName: elementsTypeInfoByName,
            pageEnabledFallback: pageEnabledFallback,
            isDisplayMode: isDisplayMode,
            textUpdateMode: textUpdateMode,
            clearInvisibleValues: clearInvisibleValues,
            storeOthersAsComment: storeOthersAsComment,
        } }, { children: children })));
};
export var useFormLogic = function () {
    var context = useContext(FormLogicContext);
    if (!context) {
        return defaultContextValue;
    }
    return context;
};
export var useElementConditions = function (element) {
    var _a = useFormLogic(), formValues = _a.formValues, elementsTypeInfoByName = _a.elementsTypeInfoByName, pageEnabledFallback = _a.pageEnabledFallback, isDisplayMode = _a.isDisplayMode;
    return useMemo(function () {
        var conditions = evaluateElementConditions(element, formValues, elementsTypeInfoByName, pageEnabledFallback);
        return __assign(__assign({}, conditions), { isInteractive: conditions.isEnabled && !isDisplayMode });
    }, [
        element,
        formValues,
        elementsTypeInfoByName,
        pageEnabledFallback,
        isDisplayMode,
    ]);
};
export default FormLogicProvider;
